var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3LoeschwassermengeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83.029,
    height: 83.03,
    viewBox: "0 0 83.029 83.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1959",
    "data-name": "Rechteck 1959",
    width: 83.029,
    height: 83.03,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3-loeschwassermenge-active",
    "data-name": "3-loeschwassermenge-active",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_667",
    "data-name": "Gruppe 667",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4121",
    "data-name": "Pfad 4121",
    d: "M82.684,41.93A40.754,40.754,0,1,1,41.929,1.176,40.754,40.754,0,0,1,82.684,41.93",
    transform: "translate(-0.415 -0.415)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4122",
    "data-name": "Pfad 4122",
    d: "M41.515,83.03A41.515,41.515,0,1,1,83.029,41.515,41.562,41.562,0,0,1,41.515,83.03m0-81.508A39.994,39.994,0,1,0,81.509,41.515,40.039,40.039,0,0,0,41.515,1.521",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4123",
    "data-name": "Pfad 4123",
    d: "M59.881,70.769A8.338,8.338,0,1,1,68.22,62.43a8.349,8.349,0,0,1-8.338,8.338m0-15.726a7.388,7.388,0,1,0,7.388,7.388,7.4,7.4,0,0,0-7.388-7.388",
    transform: "translate(-18.2 -19.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4124",
    "data-name": "Pfad 4124",
    d: "M61.233,69.506a5.679,5.679,0,1,1,5.679-5.679,5.685,5.685,0,0,1-5.679,5.679m0-10.407a4.728,4.728,0,1,0,4.728,4.728A4.734,4.734,0,0,0,61.233,59.1",
    transform: "translate(-19.616 -20.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4125",
    "data-name": "Pfad 4125",
    d: "M71.4,82.874H39.581a.475.475,0,0,1-.475-.475V78.831a1.257,1.257,0,0,1,1.256-1.255h1.793a.306.306,0,0,0,.3-.3V50.835a.475.475,0,1,1,.95,0V77.271a1.257,1.257,0,0,1-1.255,1.256H40.362a.3.3,0,0,0-.3.3v3.092H70.922v-2.6a.515.515,0,0,0-.514-.515H46.8a.475.475,0,1,1,0-.95h23.6a1.467,1.467,0,0,1,1.465,1.465V82.4a.475.475,0,0,1-.475.475",
    transform: "translate(-13.809 -17.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4126",
    "data-name": "Pfad 4126",
    d: "M68.045,71.9a.475.475,0,0,1-.475-.475V44.991a1.256,1.256,0,0,1,1.256-1.255h1.793a.305.305,0,0,0,.3-.3V40.339H40.057v2.605a.515.515,0,0,0,.514.514h23.6a.475.475,0,1,1,0,.951h-23.6a1.466,1.466,0,0,1-1.465-1.465V39.863a.475.475,0,0,1,.475-.475H71.4a.475.475,0,0,1,.475.475v3.568a1.256,1.256,0,0,1-1.255,1.255H68.825a.305.305,0,0,0-.3.3V71.427a.475.475,0,0,1-.475.475",
    transform: "translate(-13.809 -13.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4127",
    "data-name": "Pfad 4127",
    d: "M51.2,56.164a.475.475,0,0,1-.475-.475V51.422a.475.475,0,1,1,.951,0v4.266a.475.475,0,0,1-.475.475",
    transform: "translate(-17.911 -17.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4128",
    "data-name": "Pfad 4128",
    d: "M51.2,89.129a.475.475,0,0,1-.475-.475V81.284a.475.475,0,1,1,.951,0v7.369a.475.475,0,0,1-.475.475",
    transform: "translate(-17.911 -28.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4129",
    "data-name": "Pfad 4129",
    d: "M59.006,90.486a.475.475,0,0,1-.475-.475V85.127a.475.475,0,0,1,.951,0v4.884a.475.475,0,0,1-.475.475",
    transform: "translate(-20.668 -29.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4130",
    "data-name": "Pfad 4130",
    d: "M68.913,90.486a.475.475,0,0,1-.475-.475V85.127a.475.475,0,0,1,.951,0v4.884a.475.475,0,0,1-.475.475",
    transform: "translate(-24.166 -29.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4131",
    "data-name": "Pfad 4131",
    d: "M59.006,53.428a.475.475,0,0,1-.475-.475V51.533a.475.475,0,1,1,.951,0v1.419a.475.475,0,0,1-.475.475",
    transform: "translate(-20.668 -18.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4132",
    "data-name": "Pfad 4132",
    d: "M68.913,53.428a.475.475,0,0,1-.475-.475V51.533a.475.475,0,1,1,.951,0v1.419a.475.475,0,0,1-.475.475",
    transform: "translate(-24.166 -18.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4133",
    "data-name": "Pfad 4133",
    d: "M77.469,56.164a.475.475,0,0,1-.475-.475V51.422a.475.475,0,1,1,.951,0v4.266a.475.475,0,0,1-.475.475",
    transform: "translate(-27.187 -17.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4134",
    "data-name": "Pfad 4134",
    d: "M77.469,89.129a.475.475,0,0,1-.475-.475V81.284a.475.475,0,1,1,.951,0v7.369a.475.475,0,0,1-.475.475",
    transform: "translate(-27.187 -28.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4135",
    "data-name": "Pfad 4135",
    d: "M69.5,31.744a.475.475,0,0,1-.475-.475,11.468,11.468,0,1,0-22.937,0,.475.475,0,1,1-.951,0,12.419,12.419,0,0,1,24.839,0,.475.475,0,0,1-.475.475",
    transform: "translate(-15.937 -6.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4136",
    "data-name": "Pfad 4136",
    d: "M66.53,31.744a.475.475,0,0,1-.475-.475c0-6.217-2.26-11.469-4.935-11.469s-4.935,5.252-4.935,11.469a.475.475,0,1,1-.951,0c0-6.964,2.586-12.419,5.885-12.419s5.885,5.455,5.885,12.419a.475.475,0,0,1-.475.475",
    transform: "translate(-19.504 -6.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4137",
    "data-name": "Pfad 4137",
    d: "M39.418,70.769H37.606a1.477,1.477,0,0,1-1.475-1.476V68.031H34.824a1.366,1.366,0,0,1-1.366-1.365V58.124a1.367,1.367,0,0,1,1.366-1.365h1.307V55.568a1.477,1.477,0,0,1,1.475-1.475h1.813a.475.475,0,0,1,0,.95H37.606a.525.525,0,0,0-.523.525V57.71H34.824a.415.415,0,0,0-.415.414v8.542a.416.416,0,0,0,.415.415h2.259v2.213a.524.524,0,0,0,.523.525h1.813a.475.475,0,0,1,0,.951",
    transform: "translate(-11.814 -19.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4138",
    "data-name": "Pfad 4138",
    d: "M87.488,70.769H85.676a.475.475,0,1,1,0-.951h1.812a.525.525,0,0,0,.525-.525V67.081h2.258a.416.416,0,0,0,.415-.415V58.124a.415.415,0,0,0-.415-.414H88.013V55.568a.525.525,0,0,0-.525-.525H85.676a.475.475,0,1,1,0-.95h1.812a1.477,1.477,0,0,1,1.476,1.475v1.191h1.307a1.367,1.367,0,0,1,1.366,1.365v8.542a1.367,1.367,0,0,1-1.366,1.365H88.964v1.263a1.477,1.477,0,0,1-1.476,1.476",
    transform: "translate(-30.085 -19.1)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3LoeschwassermengeActive);
export default __webpack_public_path__ + "static/media/3-loeschwassermenge-active.4bb9d13f8147cd249085e24c856119de.svg";
export { ForwardRef as ReactComponent };